import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import classes from './Stories.module.scss';
import Story from '../../interfaces/Story';
import StoryProps from '../../interfaces/props/StoryProps';
import { Interweave } from 'interweave';

const Stories = ({ stories }: StoryProps) => {
  return (
    <Box>
      <Accordion className={`${classes['accordion-box']} py-3 ps-2`}
        sx={{
          '&:before': {
            display: 'none',
          }
        }}
        elevation={0}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography className='h4 ps-2'>Stories</Typography>
          <Typography className={`${classes['stories-number']} ps-2 h5`}>({stories.length})</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            {stories.map((stories: Story) => (
              <Accordion key={stories.id} className={`${classes['accordion-box']} ${classes['story-border']} border py-2 ps-2 mb-3`}
                sx={{
                  '&:before': {
                    display: 'none',
                  }
                }}
                elevation={0}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography>{stories.attributes.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Interweave content={stories.attributes.content} />
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Stories;
